import React from 'react';

import { renderComponent } from 'app/src/components/ComponentWrapper';
import type { Board } from './PluginHeaderButton.types';
import { PluginHeaderButtons } from './PluginHeaderButtons';

export const renderPluginHeaderButtons = (
  container: Element,
  board: Board,
  openPluginSettings: (pluginId: string) => void,
) => {
  if (!container) {
    return;
  }

  return renderComponent(
    React.createElement(PluginHeaderButtons, {
      container,
      board,
      openPluginSettings,
    }),
    container,
  );
};
